import PalletPrintingButton from 'components/PalletPrintingButton/PalletPrintingButton';
import { Label } from 'semantic-ui-react';

export const getColumns = ({
  preparationOrder,
  isBatchPrinting,
  setIsBatchPrinting = () => {},
  onBatchPrintingFinished = () => {},
}) => [
  {
    Header: 'EAN',
    accessor: 'ean',
    disableSortBy: true,
    width: 60,
    Cell: ({ value, row }) => {
      const hasExternalLabel = !!preparationOrder.labels?.find(
        (label) => label.ean === value,
      )?.external_label_id;

      return hasExternalLabel ? (
        <>
          {value}
          &nbsp;
          <Label size="mini" color="teal">
            Et. externa
          </Label>
        </>
      ) : (
        value
      );
    },
  },
  {
    Header: 'SKU',
    accessor: 'sku',
    disableSortBy: true,
    width: 20,
  },
  {
    Header: 'Total unidades',
    accessor: 'total_unidades',
    disableSortBy: true,
    textAlign: 'center',
    width: 30,
  },
  {
    Header: 'Total pallet',
    accessor: 'pallets',
    disableSortBy: true,
    textAlign: 'center',
    width: 30,
  },
  {
    Header: 'Resto',
    accessor: 'resto',
    disableSortBy: true,
    textAlign: 'center',
    width: 20,
  },
  {
    Header: 'Etiquetas restantes',
    accessor: 'pendingLabels',
    disableSortBy: true,
    textAlign: 'center',
    width: 40,
  },
  {
    Header: 'Etiquetas externas restantes',
    accessor: 'pendingExternalLabels',
    disableSortBy: true,
    textAlign: 'center',
    width: 40,
  },
  {
    Header: 'Pallet',
    accessor: 'units_per_pallet',
    disableSortBy: true,
    textAlign: 'center',
    width: 20,
    Cell: ({ row }) => (
      <PalletPrintingButton
        row={row.original}
        preparationOrder={preparationOrder}
        isBatchPrinting={isBatchPrinting}
        onBatchPrintingFinished={onBatchPrintingFinished}
        setIsBatchPrinting={setIsBatchPrinting}
      />
    ),
  },
];
